module.exports = __webpack_public_path__ + "img/user.a781e562.svg";